import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="login"
export default class extends Controller {
  static targets = ["emailStep", "optionsStep", "emailDisplay", "emailInput", "passwordField"]
  static values = { email: String }

  connect() {
    // Si on a une erreur d'authentification (flash alert présent) et un email,
    // afficher directement l'étape 2 (options/mot de passe)
    const alertElement = document.querySelector('[data-flash-alert]')
    const emailFromParams = this.data.get("initialEmail")

    if (alertElement && emailFromParams) {
      this.emailValue = emailFromParams
      this.showOptionsStep()
    } else {
      // Sinon, commencer par l'étape email
      this.showEmailStep()
    }
  }

  // Soumettre l'email et passer aux options
  submitEmail(event) {
    event.preventDefault()

    const email = this.emailInputTarget.value.trim()

    if (!email || !this.isValidEmail(email)) {
      this.emailInputTarget.classList.add("border-red-500")
      return
    }

    this.emailInputTarget.classList.remove("border-red-500")
    this.emailValue = email
    this.showOptionsStep()
  }

  // Valider l'email (basique)
  isValidEmail(email) {
    return email.includes('@') && email.includes('.')
  }

  // Afficher l'étape 1 (email)
  showEmailStep() {
    this.emailStepTarget.classList.remove("hidden")
    this.optionsStepTarget.classList.add("hidden")
    this.emailInputTarget.value = this.emailValue || ""
    this.emailInputTarget.focus()
  }

  // Afficher l'étape 2 (options)
  showOptionsStep() {
    this.emailStepTarget.classList.add("hidden")
    this.optionsStepTarget.classList.remove("hidden")
    this.emailDisplayTarget.textContent = this.emailValue

    // Remplir les champs email cachés des formulaires
    document.querySelectorAll('input[name="email"][type="hidden"]').forEach(input => {
      input.value = this.emailValue
    })
    document.querySelectorAll('input[name="email_address"]').forEach(input => {
      input.value = this.emailValue
    })

    // Focus sur le champ password si visible
    if (this.hasPasswordFieldTarget) {
      this.passwordFieldTarget.focus()
    }
  }

  // Revenir à l'étape 1
  changeEmail(event) {
    event.preventDefault()
    this.emailValue = ""
    this.showEmailStep()
  }

  // Soumettre le magic link
  submitMagicLink(event) {
    // Le formulaire se soumet normalement
  }

  // Soumettre le password
  submitPassword(event) {
    // Le formulaire se soumet normalement
  }
}
